<template>
  <div class="main-r-wrap">
    <div class="main-r-top">
      <span class="main-r_top_nav active">{{$t('apiDoc.在线文档')}}</span>
      <!-- 测试工具已屏蔽
      <span class="main-r_top_nav" :class="mainStatus === 'apiTest' && 'active'" @click.stop="handleClick('apiTest')">{{$t('apiDoc.测试工具')}}</span>
      -->
    </div>
    <div class="main-r-bottom">
      <online-doc :onlineData="onlineData"></online-doc>
    </div>
    <!-- 测试工具已屏蔽
    <div class="main-r-bottom" v-show="mainStatus === 'apiTest'">
      <api-test-doc :apiTestData="apiTestData"></api-test-doc>
    </div>
    -->
  </div>
</template>
<script>
import onlineDoc from "../components/onlineDoc";
// import apiTestDoc from "../components/apiTestDoc";
import {OPEN_API_TEST,OPEN_API_PRO} from '@/constants/index'
const apiUrlTest = 'customs/printOrder';
export default {
  components: { onlineDoc },
  data() {
    return {
      apiBaseUrl: process.env.VUE_APP_API_URL + `/${apiUrlTest}`,
      onlineData: {
        apiDesc: `${this.$t('customsDoc.printOrderDesc')}`,
        testApi: `${OPEN_API_TEST}/${apiUrlTest}`,
        proApi: `${OPEN_API_PRO}/${apiUrlTest}`,
        postDataList: [
          { title: `${this.$t('onlineDoc.Headers')}`, value: [
              {name: "apiAccount", type: "Number", require: "Y", normal: "", describe: `${this.$t('onlineDoc.接入方在平台的api账户标识')}`},
              {name: "digest", type: "String", require: "Y", normal: "", describe: `${this.$t('onlineDoc.签名字符串')}`},
              {name: "timestamp", type: "Number", require: "Y", normal: "", describe: `${this.$t('onlineDoc.时间戳，毫秒')}`},
          ]},
          { title: `${this.$t('onlineDoc.请求参数')}`, value: [
              {name: "bizContent", type: "String", require: "Y", normal: `${this.$t('onlineDoc.业务参数')}`, describe: `${this.$t('onlineDoc.业务参数模块内json格式的string类型')}`},
          ]},
          { title: `${this.$t('onlineDoc.业务参数')}`, value: [
              {name: "customerCode", type: "String", require: "Y", normal: "J0086474299", describe: `${this.$t('onlineDoc.客户编码（联系出货网点提供）')}`},
              {name: "digest", type: "String", require: "Y", normal: `${this.$t('onlineDoc.明文密码:H5CD3zE6')}`, describe: `${this.$t('customsDoc.digestDesc')}`},
              {name: "billCode", type: "String(50)", require: "Y", normal: "", describe: `${this.$t('customsDoc.billCode')}`},
              {name: "type", type: "int", require: "Y", normal: "1", describe: `${this.$t('customsDoc.printType')}`},
          ]}
        ],
        responseDataList: [
          { title: `${this.$t('onlineDoc.响应参数')}`, value: [
              {name: "code", type: "String", require: "Y", normal: "", describe: `${this.$t('onlineDoc.返回码，见附录')}`},
              {name: "msg", type: "String", require: "Y", normal: "", describe: `${this.$t('onlineDoc.描述')}`},
              {name: "data", type: "Object", require: "Y", normal: "", describe: `${this.$t('onlineDoc.业务数据')}`},
          ]},
          { title: `${this.$t('onlineDoc.data类型说明')}`, value: [
              {name: "billCode", type: "String", require: "Y", normal: "", describe: `${this.$t('customsDoc.billCode')}`},
              {name: "base64EncodeContent", type: "String", require: "Y", normal: "", describe: `${this.$t('customsDoc.base64Desc')}`},
          ]}
        ],
        requestCode: `{
    "billCodes": ["U88000139862302"],
    "customerCode": "J0086024037",
    "digest": "M6Iv3ynWh6i1+/SS+3aqYQ==",
    "type": 1
}`,
        responseCode: { "msg": "success", "code": "1", "data": [{"base64EncodeContent": ["base64字符串"],"billCode": "U88000139978331"}] },
        errcodeJson: []
      },
      // apiTestData 已屏蔽
      // apiTestData: { ... }
    }
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>@import "../../css/apiTest.scss";</style>